import React from "react";
import { useIntl } from "react-intl";
import SelectWithLabel from "../SelectWithLabel";

const ReportYearEventFilter = ({
  years,
  events,
  onChangeYear,
  onChangeEvent,
  eventFieldDisabled,
  validationBlur,
  eventFieldName = "event",
  yearFieldName = "year",
  eventLabelId = "event_edition",
  required = true,
  eventRequired = required,
  eventIsMulti = false,
  eventClearable = false,
}) => {
  const intl = useIntl();

  return (
    <>
      <SelectWithLabel
        name={yearFieldName}
        validationBlur={validationBlur}
        label={intl.formatMessage({ id: "year" })}
        placeholder={intl.formatMessage({ id: "year" })}
        labelOrientation="vertical"
        options={years}
        onChange={onChangeYear}
        required
      />
      <SelectWithLabel
        name={eventFieldName}
        validationBlur={validationBlur}
        label={intl.formatMessage({ id: eventLabelId })}
        placeholder={intl.formatMessage({ id: eventLabelId })}
        labelOrientation="vertical"
        options={events}
        onChange={onChangeEvent}
        disabled={eventFieldDisabled}
        noOptionsMessage={() =>
          intl.formatMessage({ id: "report_filter_no_events_for_year" })
        }
        isMulti={eventIsMulti}
        clearable={eventClearable}
        required={eventRequired}
      />
    </>
  );
};

export default ReportYearEventFilter;
